import axiosClient from "../axiosInstance";

const base = "/user-profile";

export const getUserProfile = async () => {
  const response = await axiosClient.get(`${base}`);
  return response.data;
};

export const updateUserProfile = async (profileData) => {
  const response = await axiosClient.put(`${base}`, profileData);
  return response.data;
};

const userProfileService = {
  getUserProfile,
  updateUserProfile,
};

export default userProfileService;
